var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersBtnIco5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.28404C0 1.72489 1.26395 0.460938 2.82311 0.460938H18.1769C19.7361 0.460938 21 1.72488 21 3.28404V15.7157C21 17.2749 19.7361 18.5388 18.1769 18.5388H2.82311C1.26395 18.5388 0 17.2749 0 15.7157V3.28404ZM2.82311 1.77344C1.98882 1.77344 1.3125 2.44976 1.3125 3.28404V7.1907H9.84375V1.77344H2.82311ZM11.1562 1.77344V7.1907H19.6875V3.28404C19.6875 2.44976 19.0112 1.77344 18.1769 1.77344H11.1562ZM19.6875 8.5032H11.1562V12.2085H19.6875V8.5032ZM19.6875 13.521H11.1562V17.2263H18.1769C19.0112 17.2263 19.6875 16.55 19.6875 15.7157V13.521ZM9.84375 17.2263V13.521H1.3125V15.7157C1.3125 16.55 1.98882 17.2263 2.82311 17.2263H9.84375ZM1.3125 12.2085H9.84375V8.5032H1.3125V12.2085Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersBtnIco5);
export default __webpack_public_path__ + "static/media/users-btn-ico-5.ca2d4b7343e9dd697f61185326894e1c.svg";
export { ForwardRef as ReactComponent };